import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync } from '../../core/ComponentSync.js';
import { _className } from '../../utils/tools.js';
import './TS_CheckboxGroup.scss';
import { TS_Checkbox } from '../TS_Checkbox/index.js';
import { LL_V_L } from '../Layouts/index.js';
import { BadImplementationException } from '@nu-art/ts-common';
/**
 * Checkbox Group Component
 * Handles grouped selection logic for checkboxes.
 */
export class TS_CheckboxGroup extends ComponentSync {
    constructor(p) {
        super(p);
    }
    deriveStateFromProps(nextProps, state) {
        state.selectedIds = nextProps.selectedIds;
        state.options = nextProps.options;
        if (!state.options.length)
            throw new BadImplementationException('cannot have checkbox group without options');
        state.allSelected = (state.selectedIds.length === state.options.length);
        state.someSelected = !state.allSelected && state.selectedIds.length > 0;
        state.parent = nextProps.parent;
        state.className = nextProps.className;
        return state;
    }
    onClickFather = () => {
        const { options, allSelected, selectedIds } = this.state;
        const selectableOptions = options.filter(option => !option.disabled);
        const newSelectedIds = allSelected || selectableOptions.length === selectedIds.length
            ? new Set()
            : new Set(selectableOptions.map(option => option.id));
        this.props.onChange([...newSelectedIds]);
    };
    onClickCheckbox = (id) => {
        const newSelectedIds = new Set(this.state.selectedIds);
        if (newSelectedIds.has(id))
            newSelectedIds.delete(id);
        else
            newSelectedIds.add(id);
        this.props.onChange([...newSelectedIds]);
    };
    render() {
        const { selectedIds, someSelected, allSelected, options, parent, className } = this.state;
        return (_jsxs(LL_V_L, { className: _className('ts-checkbox-group', className), id: this.props.id, children: [_jsx(TS_Checkbox, { checked: allSelected, className: _className('ts-checkbox-group__parent', someSelected && 'ts-checkbox-group__partial'), disabled: parent.disabled, onCheck: this.onClickFather, children: parent.label }), _jsx(LL_V_L, { className: 'ts-checkbox-group__children', children: options.map(option => (_jsx(TS_Checkbox, { checked: selectedIds.includes(option.id), disabled: option.disabled || parent.disabled, onCheck: () => this.onClickCheckbox(option.id), children: option.label }, option.id))) })] }));
    }
}
//# sourceMappingURL=TS_CheckboxGroup.js.map